import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [ "checker" ]

    connect() {

    }

    checkAll(event) {
        event.preventDefault();

        this.checkerTargets.forEach((checkbox)=>{
            checkbox.checked = !checkbox.checked;
        });
    }
}
